// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPage_container__Ytloi","box":"ErrorPage_box__di6VJ","icon":"ErrorPage_icon__1c5Df","title":"ErrorPage_title__2gSpT","message":"ErrorPage_message__192JV"};